var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-button',{staticClass:"mr-1",attrs:{"pressed":_vm.buttonBarcodeScanner,"variant":"success"},on:{"click":function($event){$event.preventDefault();return $event.target.blur()},"update:pressed":function($event){_vm.buttonBarcodeScanner=$event}}},[_vm._v("\n    "+_vm._s(_vm.textBarcodeScanner)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }